import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=5b0c91f6&scoped=true"
import script from "./Center.vue?vue&type=script&lang=js"
export * from "./Center.vue?vue&type=script&lang=js"
import style0 from "./Center.vue?vue&type=style&index=0&id=5b0c91f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c91f6",
  null
  
)

export default component.exports